import IndustryCard from './IndustryCard';

export default function IndustryList({
  entries = [],
  Component = IndustryCard,
}) {
  return <>{entries.map(Component)}</>;
}
